import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createFinancialAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface FinancialAssessmentResult {
  id: string;
  assessmentType: string;
  selectedCategory: number; // 1 = Budgeting, 2 = Savings, 3 = Investment
  scores: {
    overall: number;
    ifdwfScore: number;
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const FinancialAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const assessmentResult = location.state?.assessmentResult as FinancialAssessmentResult;
  
  if (!assessmentResult || !assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    const config = createFinancialAssessmentConfig(assessmentResult);
    
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default FinancialAssessmentCompletionPage;



